import { useCallback, useState } from "react";
export function useTextInput(initialValue) {
    const [value, setValue] = useState(initialValue !== null && initialValue !== void 0 ? initialValue : undefined);
    const handleChange = useCallback((event) => {
        setValue(event.target.value);
    }, []);
    return { inputProps: { value: value, onChange: handleChange }, setValue };
}
export function useCheckbox(initialValue) {
    const [checked, setChecked] = useState(initialValue !== null && initialValue !== void 0 ? initialValue : false);
    const handleChange = useCallback((_, e) => {
        var _a;
        setChecked((_a = e === null || e === void 0 ? void 0 : e.checked) !== null && _a !== void 0 ? _a : false);
    }, []);
    return { inputProps: { checked, onChange: handleChange }, setChecked };
}
